module.exports = __webpack_public_path__ + "static/media/disease.96dbb96c.svg";